import * as React from "react";
const IconScooter = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M49.8 6.8H39c-1-2.9-3.7-5.1-7-5.1s-6 2.1-7 5.1H14.2C13 6.8 12 7.8 12 9s1 2.2 2.2 2.2h7.6c-2.9 2.1-4.7 5.5-4.7 9.2v21.1c0 4.9 3.1 9.2 7.6 10.7V56c0 3.4 2.8 6.2 6.2 6.2h2.2c3.4 0 6.2-2.8 6.2-6.2v-3.7c4.5-1.5 7.6-5.8 7.6-10.7V20.5c0-3.7-1.8-7.1-4.7-9.2h7.6c1.2 0 2.2-1 2.2-2.2s-.9-2.3-2.2-2.3M32 6.2c1.6 0 2.8 1.3 2.8 2.8s-1.3 2.8-2.8 2.8-2.8-1.3-2.8-2.8 1.2-2.8 2.8-2.8m1.1 51.6h-2.2c-1 0-1.8-.8-1.8-1.8v-7.3c0-1 .8-1.8 1.8-1.8h2.2c1 0 1.8.8 1.8 1.8V56c-.1 1-.8 1.8-1.8 1.8m9.4-16.2c0 2.5-1.3 4.6-3.3 5.8-.6-2.8-3.1-4.9-6.1-4.9h-2.2c-3 0-5.5 2.1-6.1 4.9-2-1.2-3.3-3.4-3.3-5.8V20.5c0-3.1 2.1-5.7 5-6.6 1.3 1.5 3.3 2.5 5.5 2.5s4.1-1 5.5-2.5c2.9.8 5 3.5 5 6.6z" />
  </svg>
);
export default IconScooter;
